import { useState, useEffect, useRef } from "react"
import withStyles from "react-jss"
import Parser from "html-react-parser"
import { RangeSlider } from "../index"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import {
  SCROLLY_TEXTBOX_INNER_PADDING,
  SCROLLY_TEXTBOX_OUTER_PADDING,
} from "../../data/globalStyles"

const squareVariants = {
  partial: {
    opacity: 0.5,
    transition: {
      ease: "easeOut",
      duration: 1,
    },
  },
  visible: {
    opacity: 1,
    transition: {
      ease: "easeOut",
      duration: 0.5,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      ease: "easeOut",
      duration: 0.5,
    },
  },
}
const styles = {
  main: {
    position: "relative",
    width: "100%",
    display: "flex",
    maxWidth: "1140px",
    margin: "0 auto",
    padding: "15px 0",
    color: "#ffffff",
    boxSizing: "border-box",
    "@media only screen and (max-width: 840px)": {
      flexDirection: "column",
      padding: "0",
    },
    "@media only screen and (max-width: 310px)": {
      margin: "0 auto 3rem auto",
    },
  },
  right: {
    boxSizing: "border-box",
    position: "relative",
    width: "55%",
    margin: 0,
    // background: "grey",
    "@media only screen and (max-width: 840px)": {
      position: "sticky",
      bottom: "0px",
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      height: "100vh",
    },
  },
  left: {
    boxSizing: "border-box",
    width: "45%",
    zIndex: 2,
    "@media only screen and (max-width: 840px)": {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
    },
    "& p": {
      fontFamily: "BreveText",
      fontSize: "19px",
    },
    ...SCROLLY_TEXTBOX_OUTER_PADDING,
  },
  text: {
    width: "100%",
    maxWidth: "460px",
    boxSizing: "border-box",
    fontFamily: "BreveText",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "19px",
    margin: "80vh auto",
    padding: SCROLLY_TEXTBOX_INNER_PADDING.padding,
    background: "#ffffff",
    borderRadius: "4px",
    color: "#000000",
    "@media only screen and (max-width: 840px)": {
      padding:
        SCROLLY_TEXTBOX_INNER_PADDING[
          "@media only screen and (max-width: 840px)"
        ].padding,
      margin: "100vh auto",
    },
  },
  rightBox: {
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "sticky",
    alignItems: "center",
    top: "7%",
    flexDirection: "column",
    paddingBottom: "50px",
    paddingTop: "20px",
    "@media (max-width: 780px)": {
      justifyContent: "start",
      top: "0%",
      paddingBottom: "0px",
      paddingTop: "90px",
    },
    "& p": {
      fontFamily: "WiredMono",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      display: "flex",
      justifyContent: "space-between",
      textTransform: "uppercase",
      flexDirection: "column",
      margin: 0,
    },
  },
  rightBoxHeading: {
    borderBottom: "1px solid #ffffff",
    lineHeight: "60px",
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "18px",
    "@media (max-width: 340px)": {
      margin: "0.7em 0",
    },
  },
  flexBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    margin: "15px 0px",
    "@media (max-width: 780px)": {
      margin: "10px 0px",
    },
  },
  ParaScore: {
    display: "flex",
    justifyContent: "space-between",
    borderTop: "1px solid #fff",
    lineHeight: "60px",
    flexDirection: "column",
  },

  ParaScoreSpan: {
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "700 !important",
    fontSize: "18px !important",
    display: "flex",
    flexDirection: "row !important",
    "& span": {
      margin: "8px 0px 0px 0px",
    },
  },

  ParaScoreInputs: {
    justifyContent: "center!important",
    color: "#ffffff",
    fontFamily: "WiredMono",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "12px",
    textAlign: "center",
  },
  rightBoxContent: {
    width: "80%",
    //height: "500px"
  },
  bolder: {
    fontSize: "18px",
    fontWeight: "700",
    textAlign: "right",
    verticalAlign: "bottom",
  },
  slider: {
    // paddingTop: "10px",
    //width: "80%",
    textAlign: "center",
  },
  label: {
    display: "inline-flex",
  },
  dots: {
    // minWidth: "15px",
  },
  container1: {
    position: "relative",
    display: "inline-flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    margin: "15px 0px",
    overflow: "hidden",
    "@media (max-width: 780px)": {
      margin: "10px 0px",
    },
    "@media (max-width: 340px)": {
      margin: "8px 0px",
    },
    "&:after": {
      content:
        '"........................................................................................................................................................................................................." / ""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
    },
  },
  label1: {
    position: "relative",
    background: "black",
    zIndex: 2,
    paddingRight: "5px",
    textAlign: "left",
    // maxWidth: "min-content",
    // minWidth: "20px"
  },
  label3: {
    fontSize: "18px",
    fontWeight: "700",
    textAlign: "right",
    verticalAlign: "bottom",
    background: "black",
    zIndex: 2,
    paddingLeft: "5px",
  },
}

const CaseCard = ({ classes, arcData, toggle = false, mainId }) => {
  const [load, setLoad] = useState(false)

  const [stateData, setStateData] = useState(arcData.data[0])

  const controls = useAnimation()
  const [ref, inView] = useInView()
  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView, stateData])

  const articleRef = useRef([])

  useEffect(() => {
    const items =
      (articleRef.current.children &&
        Array.from(articleRef.current.children).map((item, i) => {
          return item.children[0]
        })) ||
      []

    const detectIntersection = (entries) => {
      for (let e of entries) {
        let j = items.indexOf(e.target)
        if (e.isIntersecting) {
          setStateData(arcData.data[j])
        }
      }
    }

    const options = {
      threshold: 0.25,
    }

    const observer = new IntersectionObserver(detectIntersection, options)
    items.forEach((i) => {
      //setAnimate(true)
      observer.observe(i)
    })

    return () => {
      items.forEach((i) => {
        //setAnimate(false)
        observer.unobserve(i)
      })
    }
  }, [])

  return (
    <section className={classes.main} id={mainId}>
      {(!load && (
        <>
          <article className={classes.left} ref={articleRef}>
            {arcData.data.map((row, r) => (
              <div key={r} className={classes.text}>
                {Parser(row.text)}
              </div>
            ))}
          </article>
          <figure className={classes.right}>
            <div className={classes.rightBox}>
              <div className={classes.rightBoxContent}>
                <h3 className={classes.rightBoxHeading}>{arcData.name}</h3>
                {(Object.keys(stateData).length &&
                  stateData.checks.length &&
                  stateData.checks.map((check, c) => (
                    <motion.p
                      ref={ref}
                      animate={controls}
                      initial="hidden"
                      variants={squareVariants}
                      key={c}>
                      <p className={check.animate ? "showDataTrans" : ""}>
                        {/* <span
                          className={classes.flexBox}
                          style={{ color: check.color }}>
                          <span
                            className={classes.label}
                            // style={{ flex: "0 1" }}
                          >
                            {check.label}
                          </span>
                          <span
                            className={`${classes.dots} item`}
                            aria-hidden="true"
                          />
                          <span className={classes.bolder}>
                            {(check.options &&
                              check.options.find(
                                (e) => parseInt(e.val) === parseInt(check.value)
                              ).label) ||
                              check.value}
                          </span>
                        </span> */}
                        <span
                          className={classes.container1}
                          style={{ color: check.color }}>
                          <span className={classes.label1}>{check.label}</span>
                          <span className={classes.label3}>
                            {(check.options &&
                              check.options.find(
                                (e) => parseInt(e.val) === parseInt(check.value)
                              ).label) ||
                              check.value}
                          </span>
                        </span>
                      </p>
                    </motion.p>
                  ))) || <></>}
              </div>
              {(Object.keys(stateData).length && stateData.score && (
                <motion.div
                  ref={ref}
                  animate={controls}
                  initial="hidden"
                  variants={squareVariants}
                  style={{ width: "80%" }}>
                  <div
                    className={classes.ParaScore + " boxRightContentPara"}
                    aria-live="polite"
                    aria-atomic="true">
                    <p className={classes.ParaScoreSpan}>
                      {(Object.keys(stateData).length && (
                        <span style={{ color: stateData.score.color }}>
                          SCORE
                        </span>
                      )) || <></>}
                      {(Object.keys(stateData).length && (
                        <span style={{ color: stateData.score.color }}>
                          {stateData.score.value}
                        </span>
                      )) || <></>}
                    </p>
                    {(Object.keys(stateData).length && (
                      <p className={classes.ParaScoreSpan}>
                        {(Object.keys(stateData).length && (
                          <span style={{ color: stateData.score.color }}>
                            {(stateData.inputs && stateData.inputs.name) || ""}
                          </span>
                        )) || <></>}
                        {(Object.keys(stateData).length && (
                          <span style={{ color: stateData.score.color }}>
                            {stateData.inputs.value}
                          </span>
                        )) || <></>}
                      </p>
                    )) || <></>}
                  </div>
                  <div className={classes.slider}>
                    <RangeSlider
                      rankValue={
                        (stateData &&
                          stateData.inputs &&
                          stateData.inputs.value) ||
                        0
                      }
                    />
                    <p aria-hidden="true">Fraud investigation gauge</p>
                  </div>
                </motion.div>
              )) || <></>}
            </div>
          </figure>{" "}
        </>
      )) || (
        <div className="loadBox">
          <div className="loader"></div>
        </div>
      )}
    </section>
  )
}

export default withStyles(styles)(CaseCard)
